import {
  publishLog,
  platformProductPublishLog,
  publishLogDetail,
  platformProductPublishLogDetail,
  publishLogById,
  platformProductPublishLogById,
  operatorLog,
  stopTask,
  queryLogItemImages,
  queryChannelByType,
  operatorLogDetail,
  operatorSkuLogDetail,
  goodsLog,
  productEditLogPage,
  productEditLogDetail
} from '@api/prod/log/index';
import store from '@/store'

// 铺货日志
export function getPublishLog(data = {}) {
  return publishLog(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
// 铺货日志(商品维度)
export function getPlatformProductPublishLog(data = {}) {
  return platformProductPublishLog(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
// 商品日志-商品修改
export function getProductEditLogPage(data = {}) {
  return productEditLogPage(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
// 商品日志-商品修改详情
export function getProductEditLogDetail(data = {}) {
  return productEditLogDetail(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}

export function getPublishLogDetail(data = {}) {
  return publishLogDetail(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export function getPlatformProductPublishLogDetail(data = {}) {
  return platformProductPublishLogDetail(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}

// 商品日志详情
export function logPublishLogById(data) {
  return publishLogById(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}
export function getPlatformProductPublishLogById(data) {
  return platformProductPublishLogById(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}

// 获取操作日志列表
export function getOperatorLog(data = {}) {
  return operatorLog(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
// 获取操作日志列表
export function stopPublishTask(data = {}) {
  return stopTask(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export function getCheckImagesDetail(data = {}) {
  return queryLogItemImages(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}

// 根据日志类型查询对应的途径
export function getChannelByType(data = {}) {
  return queryChannelByType(data).then((res) => {
      if (res.result === 1) {
        return res.data;
        // if (data.type === 1) {
        //   // 新增途径需要区分共分销身份展示不同途径数据
        //   const SupplierSubCode = [1, 2, 3, 26, 27]
        //   if (store.getters.userInfo?.loginIdentity === 1) {
        //     // 供销商
        //     return res.data.filter(item => SupplierSubCode.includes(item.subCode))
        //   } else {
        //     // 分销商
        //     return res.data.filter(item => !SupplierSubCode.includes(item.subCode))
        //   }
        // } else {
        //   return res.data;
        // }
      }
      return false;
  })
}

// 获取商品日志详情
export function getOperatorLogDetail(data = {}) {
  return operatorLogDetail(data).then(res=> {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

// 获取铺货日志详情【SKU维度】
export function getOperatorSkuLogDetail(data = {}) {
  return operatorSkuLogDetail(data).then(res=> {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

// 铺货日志
export function getGoodsLog(data = {}) {
  return goodsLog(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}